import { useState, useEffect } from "react";

// ═══════════════════════════════════════════════
// Imports images — logos projets
// ═══════════════════════════════════════════════
import imgFabacee      from '../../../assets/logos_partenaires/Fabacée.png';
import imgCapProteines from '../../../assets/logos_partenaires/logo-Cap-Proteines-carré.png';
import imgCulturibles  from '../../../assets/logos_partenaires/LOGO_culturibles.png';
import imgArrupVico    from '../../../assets/logos_partenaires/ARRUP_VICO.png';
import imgBetteraves   from '../../../assets/logos_partenaires/betterave.png';
import imgBleDur       from '../../../assets/logos_partenaires/BD.png';

// ═══════════════════════════════════════════════
// Imports images — logos partenaires
// ═══════════════════════════════════════════════
import imgTerresInovia   from '../../../assets/logos_partenaires/terreInnovia_logo.png';
import imgOFB            from '../../../assets/logos_partenaires/logo-ofb-actualite.jpg';
import imgEcophyto       from '../../../assets/logos_partenaires/Logo-ecophyto.png';
import imgIFV            from '../../../assets/logos_partenaires/LOGO-IFV-blanc.png';
import imgINRAE          from '../../../assets/logos_partenaires/logo-inrae.png';
import imgActa           from '../../../assets/logos_partenaires/ACTA-logo.png';
import imgLeMans         from '../../../assets/logos_partenaires/logo-universite-du-mans.png';
import imgGouvernement   from '../../../assets/logos_partenaires/logo_gouv.png';
import imgBSE            from '../../../assets/logos_partenaires/bse.png';
import imgIntercereales  from '../../../assets/logos_partenaires/Logo-INTERCEREALESV-300x132.png';
import imgFeve           from '../../../assets/logos_partenaires/feve.jpg';
import imgPluriagri      from '../../../assets/logos_partenaires/pluriagri.png';
import imgArtb           from '../../../assets/logos_partenaires/artb.png';
import imgCeresco        from '../../../assets/logos_partenaires/Cerasco_couleur.png';

// ═══════════════════════════════════════════════
// CSS injecté dans le <head> au montage
// ═══════════════════════════════════════════════
const CSS = `
  :root {
    --dr-green: #92D050;
    --dr-green-light: #EAF4D8;
    --dr-navy: #000000;
    --dr-blue: #92D050;
    --dr-blue-light: #EAF4D8;
    --dr-radius: 12px;
    --dr-shadow: 0 2px 8px rgba(26, 33, 63, 0.08);
  }
  .projets-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 90%;
    margin: 0 auto;
  }
  .projet-card {
    background: #ffffff;
    border-radius: var(--dr-radius);
    border: 1.5px solid #e8edf2;
    box-shadow: var(--dr-shadow);
    overflow: hidden;
    transition: box-shadow 0.2s ease;
  }
  .projet-card:hover { box-shadow: 0 4px 16px rgba(26, 33, 63, 0.13); }
  .projet-card--open { border-color: var(--dr-green); }
  .projet-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 14px 18px;
    cursor: pointer;
    gap: 12px;
  }
  .projet-header-left {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    flex: 1;
    min-width: 0;
  }
  .projet-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    padding-top: 2px;
  }
  .projet-icon {
    width: 52px;
    height: 52px;
    border-radius: 8px;
    flex-shrink: 0;
    overflow: hidden;
    border: 1.5px solid #e8edf2;
    object-fit: contain;
    padding: 4px;
    background: #fff;
  }
  .projet-meta { flex: 1; min-width: 0; }
  .projet-titre {
    margin: 0 0 4px 0;
    font-weight: 700;
    color: var(--dr-navy);
    line-height: 1.2;
  }
  .projet-description {
    margin: 0;
    text-align: left;
    color: #5a6478;
    line-height: 1.4;
  }
  .badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 20px;
    font-weight: 600;
    white-space: nowrap;
  }
  .badge--en_cours {
    background: var(--dr-blue-light);
    color: var(--dr-blue);
    border: 1.5px solid #bfdbfe;
  }
  .badge--termine {
    background: var(--dr-green-light);
    color: #3d7a00;
    border: 1.5px solid #c6e89a;
  }
  .chevron-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px;
    display: flex;
    align-items: center;
  }
  .chevron-icon {
    width: 20px;
    height: 20px;
    transition: transform 0.25s ease;
    color: var(--dr-green);
  }
  .chevron-icon--up { transform: rotate(180deg); }
  .projet-body-separator {
    height: 1px;
    background: #e8edf2;
    margin: 0 18px;
  }
  .projet-body { animation: slideDown 0.22s ease; }
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .projet-body-content {
    display: flex;
    gap: 24px;
    padding: 18px 20px 20px 20px;
  }
  .projet-body-left {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .projet-texte {
    margin: 0;;
    color: var(--dr-navy);
    line-height: 1.6;
  }
  .projet-commanditaires {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }
  .logo-partenaire {
    height: 36px;
    max-width: 100px;
    object-fit: contain;
    border: 1px solid #e0e5ee;
    border-radius: 6px;
    padding: 4px 6px;
    background: #fff;
  }
  .projet-body-right {
    flex: 0 0 35%;
    margin-left: 5%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .projet-bullet {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #f7f9fc;
    border-radius: 8px;
    padding: 10px 12px;
  }
  .bullet-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 3px;
  }
  .bullet-dot--en_cours { background: var(--dr-blue); }
  .bullet-dot--termine  { background: var(--dr-green); }
  .bullet-text {
    color: var(--dr-navy);
    line-height: 1.45;
  }
  @media (max-width: 560px) {
    .projet-body-content { flex-direction: column; }
    .projet-body-right   { flex: none; width: 100%; }
  }
`;

// ═══════════════════════════════════════════════
// Données
// ═══════════════════════════════════════════════
const PROJETS = [
  {
    id: 1,
    icon: imgFabacee,
    titre: "FABACEE",
    description: "Conception d’une stratégie et d’un dispositif de sécurisation de pratiques économes en énergie",
    statut: "en_cours",
    texte: "Au travers du programme FABACEE, FEVE encourage l’adoption de pratiques d’économies d’énergie dans les exploitations agricoles. \n\nSécuriser pour accélérer l’adoption des pratiques transformatrices apparait indispensable. Mais avec quelles mesures pour aller plus vite et aller plus loin ? ",
    commanditaires: [
      { src: imgFeve, alt: "Fève" },
      { src: imgCeresco, alt: "Ceresco" },
    ],
    bullets: [
      "Caractérisation des risques objectifs et perçus associés aux pratiques économes en énergie",
      "Conception d’un Fonds de sécurisation et propositions de mesures de sécurisation",
      "Test Grandeur Nature du dispositif"
    ],
  },
  {
    id: 2,
    icon: imgBleDur,
    titre: "BLE DUR",
    description: "Faisabilité de dispositifs assurantiels pour relancer la production du blé dur",
    statut: "en_cours",
    texte: "La sécurisation constitue l’axe 1 du Plan Stratégique Blé Dur, qui, à l’initiative d’InterCéréales, fédère les acteurs pour relancer la production de Blé dur en France. \n\nNous sommes en charge d’identifier et de quantifier les solutions d’assurances qui pourront y contribuer.",
    commanditaires: [
      { src: imgIntercereales, alt: "Intercéréales" },
    ],
    bullets: [
      "Analyse des besoins et des opportunités",
      "Modélisation des risques spécifiques",
      "Propositions de dispositifs d’assurance",
      "Intérêts des parties prenantes"
    ],
  },
  {
    id: 3,
    icon: imgCapProteines,
    titre: "CAP PROTEINES +",
    description: "Évaluation du risque de doublement des surfaces en légumineuses en France",
    statut: "en_cours",
    texte: "Une légumineuse représente un risque entre 3 et 5 fois plus important que le blé. Dès lors, comment sécuriser pour atteindre l’objectif d’augmentation des surfaces ? \n\nNous étudions la sécurisation de l'introduction des légumineuses de la parcelle à la France entière. ",
    commanditaires: [
      { src: imgTerresInovia, alt: "Terres Inovia" },
    ],
    bullets: [
      "Modélisation du risque des cultures et de leur introduction dans les assolements",
      "Quantification du risque d’itinéraires techniques alternatifs",
      "Proposition pour une Stratégie nationale de sécurisation"
    ],
  },
  {
    id: 4,
    icon: imgCulturibles,
    titre: "CULTURIBLES",
    description: "Coût de l’inaction à 2050 pour exploitations Grandes Cultures des 31 terroirs de la Région Centre-Val-de-Loire",
    statut: "en_cours",
    texte: "Le changement climatique va affecter aussi les grandes cultures et les organisations agricoles spécialisées doivent arrêter leur plan d’action. \n\nPluriagri souhaite les accompagner dans cette démarche, en chiffrant le coût de l’inaction puis en définissant des stratégies robustes à partir de scénarios prospectifs",
    commanditaires: [
      { src: imgPluriagri, alt: "Pluriagri" },
    ],
    bullets: [
      "Quantification des impacts du changement climatique de 2020 à 2035 et 2050, par culture, aléas climatiques et terroir",
      "Coût du risque pour les assolements types dans 31 terroirs",
      "Evaluation de la pertinence des solutions agronomiques ou financières (assurance et épargne) dans chacun des terroirs"
    ],
  },
  
  {
    id: 5,
    icon: imgArrupVico,
    titre: "ARRUP VICO",
    description: "Assurabilité des Risques liés à la Réduction des Usages Phytosanitaires — Vigne & Colza",
    statut: "termine",
    texte: "Comment assurer les pertes de récolte liées à la réduction des pesticides sur la vigne et le colza ? Et ainsi sécuriser les agriculteurs pour accélérer l’adoption des nouvelles pratiques ? \n\nAu côté des chercheurs spécialistes des bioagresseurs et des cultures, DiagoRisk apporte son expertise de la modélisation actuarielle et de la gestion innovante de risque.",
    commanditaires: [
      { src: imgGouvernement, alt: "Gouvernement" },
      { src: imgOFB,          alt: "OFB" },
      { src: imgEcophyto,     alt: "Écophyto" },
      { src: imgIFV,          alt: "IFV" },
      { src: imgBSE,          alt: "BSE" },
      { src: imgLeMans,       alt: "Le Mans Université" },
      { src: imgINRAE,        alt: "INRAe" },
      { src: imgActa,         alt: "Acta" },
      { src: imgTerresInovia, alt: "Terres Inovia" },
    ],
    bullets: [
      "Modélisation du risque d’apparition du mildiou et de la garantie Colza Zéro Insecticide",
      "Maquette d’un OAD VitiDecid",
      "Recommandations sur les modalités et la politique publique nécessaire au déploiement de dispositif de sécurisation complet",
      "Séminaires d'échanges ouverts aux filières et assureurs (replay en ligne sur UMT seven)"

    ],
  },
  {
    id: 6,
    icon: imgBetteraves,
    titre: "BETTERAVES SANS NEONICOTINOÏDE",
    description: "Modélisation de l'interaction Climat–Puceron–Virus–Betterave à horizon 2050",
    statut: "termine",
    texte: "Est-il possible de couvrir le risque combiné de la sècheresse et de la jaunisse transmise à la betterave par les pucerons et différents virus ? A quel coût ?\n\n Est-ce une solution robuste face au changement climatique ? ",
    commanditaires: [
      { src: imgArtb, alt: "ARTB" },
    ],
    bullets: [
      "Phase 1 : chiffrage des pertes actuelles et projetées",
      "Phase 2 : efficacité des solutions alternatives en essai"
    ],
  },
];

// ═══════════════════════════════════════════════
// Composant principal
// ═══════════════════════════════════════════════
export default function ProjetsList() {
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const styleId = "projets-list-styles";
    if (!document.getElementById(styleId)) {
      const tag = document.createElement("style");
      tag.id = styleId;
      tag.textContent = CSS;
      document.head.appendChild(tag);
    }
    return () => {
      const tag = document.getElementById(styleId);
      if (tag) tag.remove();
    };
  }, []);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <div className="projets-list">
      {PROJETS.map((projet) => {
        const isOpen = openId === projet.id;
        return (
          <div
            key={projet.id}
            className={`projet-card${isOpen ? " projet-card--open" : ""}`}
          >
            {/* ── Header ── */}
            <div className="projet-header" onClick={() => toggle(projet.id)}>
              <div className="projet-header-left">
                <img src={projet.icon} alt={projet.titre} className="projet-icon" />
                <div className="projet-meta">
                  <h3 className="projet-titre paragrapheLanding">{projet.titre}</h3>
                  <p className="projet-description paragraphe">{projet.description}</p>
                </div>
              </div>
              <div className="projet-header-right">
                <button className="chevron-btn" aria-label="toggle">
                  <svg
                    className={`chevron-icon${isOpen ? " chevron-icon--up" : ""}`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
              </div>
            </div>

            {/* ── Body déroulé ── */}
            {isOpen && (
              <div className="projet-body">
                <div className="projet-body-separator" />
                <div className="projet-body-content">
                  <div className="projet-body-left">
                    {projet.texte && (
                      <p className="projet-texte paragraphe">
                        {projet.texte.split("\n\n").map((para, i, arr) => (
                          <span key={i}>
                            {para}
                            {i < arr.length - 1 && <><br /><br /></>}
                          </span>
                        ))}
                      </p>
                    )}
                    {projet.commanditaires.length > 0 && (
                      <div className="projet-commanditaires">
                        {projet.commanditaires.map((logo, i) => (
                          <img
                            key={i}
                            src={logo.src}
                            alt={logo.alt}
                            className="logo-partenaire"
                          />
                        ))}
                      </div>
                    )}
                  </div>
                  {projet.bullets.length > 0 && (
                    <div className="projet-body-right">
                      {projet.bullets.map((b, i) => (
                        <div key={i} className="projet-bullet">
                          <span className={`bullet-dot bullet-dot--${projet.statut}`} />
                          <span className="bullet-text paragraphe">{b}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
